import React from "react";
import { Container } from "reactstrap";
import ListHeader from "components/Headers/ListHeader";
import "react-datepicker/dist/react-datepicker.css";
import WizardController from "./WizardController";

export default function ExploreNetwork({ match }) {
  return (
    <>
      <ListHeader parentName={"Explore Network"} />
      <Container className="mt--6" fluid>
        <WizardController />
      </Container>
    </>
  );
}
